import React, { useContext, useEffect, useState, useLayoutEffect } from "react";
import MainContext from "./MainContext";
import Services from "../Services";
import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import {useNavigate, useHistory} from "react-router-dom";
import Index from "../../containers/LandingPage/Index";
import {
  userLogout,
  setLocalStorage,
  decryptData,
  encryptData,
} from "../UserUtil";

import keycloakData from "../../api/apps/keycloakData";
// import { json } from "express";

export function useAuth() {
  return useContext(MainContext);
}

const MainState = (props) => {
  const [getrole, setrole] = useState("");
  const [userId, setUserId] = useState("");
  const [getApiContextDetails, setApiContextDetails] = useState();
  const [isAuthenticated, authenticated] = useState(false);
  const [getErrorMsg, setErrorMsg] = useState({});
  // const navigate = useNavigate();
  const history = useHistory();

  // const secureFlag =
  //   window.location.protocol === "https:" ? { secure: true } : {};
  const secureFlag =
    window.location.protocol === "https:"
      ? { secure: true, sameSite: "strict" }
      : { secure: false, sameSite: "lax" };

  useLayoutEffect(() => {
    const urlObj = new URL(window.location.href);

    // console.log("urlObj", urlObj);

    const code = urlObj.searchParams.get("code");
    const stateValue = urlObj.searchParams.get("state");

    if (code) {
      // if (stateValue === null && code) {
      const bodyjson = {
        code: code,
        // client_id: keycloakData.ivpConference_clientID,
        client_id: keycloakData.ivp_clientID,
        state: stateValue,
      };
      // const secretKey =
      //   "6e0c6d0d6a1e3a1b9a1d5a2e4b7f8e0f9c0d8f7b9a3e4d1e6b2f4a3e5b7c8d1b";
      const getTokenGen = async () => {
        // Services.keyCloak_tokenGen(bodyjson)
        //   .then(async (response) => {
        try {
          const response = await Services.keyCloak_tokenGen(bodyjson);
          console.log("ata", response);
          if (response.status === 200) {
            let token = response.data.data.data.access_token;
            let refreshToken = response.data.data.data.refresh_token;
            let media_tokenValue = response.data.data?.media_token;
            const decodeToken = jwtDecode(token);
            const userRole = decodeToken.role;
            Cookies.set("ac_token", token, {
              expires: 1,
              // httpOnly: true,
              ...secureFlag,
            });
            Cookies.set("refToken", refreshToken, {
              expires: 1,
              ...secureFlag,
            });

            // res.cookie("ac_token", token, {
            //   httpOnly: true,
            //   ...secureFlag,
            //   maxAge: 24 * 60 * 60 * 1000,
            // });

            // res.cookie("refToken", refreshToken, {
            //   httpOnly: true,
            //   ...secureFlag,
            //   maxAge: 24 * 60 * 60 * 1000,
            // });
            Cookies.set("base_64", media_tokenValue);
            window.localStorage.setItem("Role", userRole);
            const applicationName = response.data.data?.requested_client;
            // const encryptedClient = encryptAES(applicationName, secretKey);
            // if (encryptedClient) {
            //   setLocalStorage("client", encryptedClient);
            // }
            setLocalStorage("client", applicationName);
            let user_id = decodeToken.sub;

            setUserId(user_id);
            window.localStorage.setItem("id", user_id);
            handleLoginTime();
            authenticated(true);
            const userId = {
              uid: decodeToken.sub,
            };

            let profileRole = localStorage.getItem("Role");
            setrole(profileRole);

            switch (profileRole) {
              case "admin":
                window.location.href = "/administrator/dashboard";
                break;
              case "user":
                window.location.href = "/user/dashboard";
                break;
              case "coordinator":
                window.location.href = "/ic/dashboard";
                break;
              case "pmu_admin":
                window.location.href = "/pmu/dashboard";
                break;
              case "super_admin":
                window.location.href = "/management/dashboard";
                break;
              case "meity_manager":
                window.location.href = "/meity-management/dashboard";
                break;
              default:
                window.location.href = "/notfound";
                break;
            }
            // switch (profileRole) {
            //   case "admin":
            //     history.push("/administrator/dashboard");
            //     break;
            //   case "user":
            //     history.push("/user/dashboard");
            //     break;
            //   case "coordinator":
            //     history.push("/ic/dashboard");
            //     break;
            //   case "pmu_admin":
            //     history.push("/pmu/dashboard");
            //     break;
            //   case "super_admin":
            //     history.push("/management/dashboard");
            //     break;
            //   case "meity_manager":
            //     history.push("/meity-management/dashboard");
            //     break;
            //   default:
            //     history.push("/notfound");
            //     break;
            // }
            
          }
        } catch (err) {
          const errorMsg = err.response?.data?.errors;
          setErrorMsg(errorMsg);
          if (err.response?.status === 401 || err.response?.status === 500) {
            // console.log("500");
            Swal.fire({
              title: "Error",
              text: errorMsg,
              icon: "error",
            }).then(() => {
              if (Cookies.get("refToken")) {
                // console.log("inside log");
                userLogout();
              } else {
                window.location.href = "/";
              }
            });
          } else if (err.response?.status === 400) {
            Swal.fire({
              title: "Error",
              text: errorMsg,
              icon: "error",
            }).then(() => {
              if (Cookies.get("refToken")) {
                userLogout();
              }
            });
          } else if (err.response?.status === 503) {
            Swal.fire({
              title: "Error",
              text: "Serverice Unavailable, Kindly Wait for for Sometime...",
              icon: "error",
            }).then(() => {
              if (Cookies.get("refToken")) {
                userLogout();
              }
            });
          } else {
            // console.log("ëlse");
            Swal.fire({
              title: "Error",
              text: errorMsg,
              icon: "error",
            }).then(() => {
              console.log("inside log");
              if (Cookies.get("refToken")) {
                userLogout();
              } else {
                window.location.href = "/";
              }
            });
          }
        }
        // });
      };
      getTokenGen();
    }
  }, []);

  const handleLoginTime = () => {
    localStorage.setItem("LoginTime", Date.now());
  };

  useLayoutEffect(() => {
    const user_ID = window.localStorage.getItem("id");

    if (user_ID) {
      const userID = {
        uid: user_ID,
        // "x-api-key": process.env.SHOW_PROFILE_KEY,
      };

      const encData = encryptData(userID);
      console.log("encData", encData);
      const newBody = {
        key: encData,
      };
      Services.getUserProfileByKeyCloakId(userID)
        // Services.getUserProfileByKeyCloakId(newBody)
        .then(async (response) => {
          // console.log("token res", response);
          if (response.status === 200) {
            console.log("token res in", response);
            let userInfoDetails = response.data.data;

            // const jsonString = decryptData(userInfoDetails);

            // const fixed = jsonString
            //   .replace(/([\s{,])'([^']+?)'\s*:/g, '$1"$2":')
            //   .replace(/:\s*'([^']*?)'/g, ': "$1"')
            //   .replace(/\bTrue\b/g, "true")
            //   .replace(/\bFalse\b/g, "false")
            //   .replace(/\bNone\b/g, "null");

            // try {
            //   const obj = JSON.parse(fixed);
            //   const parsedUserData = obj.data;
            //   setApiContextDetails({ ...parsedUserData });
            // } catch (err) {
            //   console.error("JSON parsing error:", err.message);
            // }

            setApiContextDetails({ ...userInfoDetails });
          } else {
            Swal.fire({
              // title: "Error",
              text: response.data.errors,
              icon: "error",
            }).then(() => {
              userLogout();
            });
          }
        })
        .catch((err) => {
          const errorMsg = err.response?.data;
          const errorMessageText = err.response?.data?.message;
          setErrorMsg(errorMsg);

          let errorMessage = "";
          Object.keys(errorMsg).forEach(([field, value]) => {
            errorMessage += errorMsg[field] + "\n";
          });

          if (
            err.response.status === 400 ||
            err.response.status === 501 ||
            err.response.status === 404 ||
            err.response.status === 403 ||
            err.response.status === 401
          ) {
            Swal.fire({
              title: "Warning",
              text: errorMessageText || errorMessage || getErrorMsg,
              icon: "warning",
            }).then(() => {
              if (Cookies.get("refToken")) {
                window.localStorage.clear();
                Cookies.remove("ac_token");
                Cookies.remove("refToken");
                localStorage.clear();
                window.location.href = "/";
                userLogout();
              }
            });
          } else if (err.response.status === 500) {
            Swal.fire({
              title: "Warning",
              text: "Your Session has expired, kindly login again",
              icon: "warning",
            }).then(() => {
              window.localStorage.clear();
              Cookies.remove("ac_token");
              Cookies.remove("refToken");
              localStorage.clear();
              window.location.href = "/";
            });
          } else {
            Swal.fire({
              title: "Warning",
              text: errorMessageText || errorMsg || getErrorMsg,
              icon: "warning",
            }).then(() => {
              // console.log("inside log");
              if (Cookies.get("refToken")) {
                userLogout();
              }
            });
          }
        });
    }
  }, [userId]);

  // console.log("89", getApiContextDetails);

  return (
    <MainContext.Provider value={{ ...getApiContextDetails, isAuthenticated }}>
      {props.children}
      {/* {isLoading ? <Index /> : props.children} */}
    </MainContext.Provider>
  );
};

export default MainState;
